<script>
    import CustomerServiceForm from './customer-service-form.svelte'
    let formDataId = null
    const urlParams = new URLSearchParams(window.location.search)
    formDataId = urlParams.get('id')

    function goPrint() {
        setTimeout(window.print, 1000)
        setTimeout(window.close, 1500)
        console.log('go print ok')
    }
</script>

<div>
    {#if formDataId}
        <CustomerServiceForm view={true} {formDataId} on:load={goPrint}></CustomerServiceForm>
    {/if}
</div>
